import React from 'react';
import Header from '../common/Header'; // Ensure the path is correct
import SubHeader from '../common/SubHeader';
import '../styles/HomePage.css';
import ServiceSpecific from './ServiceSpecific';

const Service = () => {
  return (
    <div className='container-fluid d-flex flex-column w-100 p-0 m-0'>
      <Header />
      <div className='bg-secondary'><SubHeader /></div>
      <ServiceSpecific />
    </div>
  );
};

export default Service;

